import axios from 'axios'
import { capiCreator } from 'tr-components/redux/CallApiMiddlewareActionCreator'

export const initalState = {
  fetchingLanguages: false,
  fetchedLanguages: false,
  fetchingLanguagesError: null,
  languages: []
}

const FETCH_SUPPORTED_LANGUAGES = 'languages/FETCH_SUPPORTED_LANGUAGES'
const FETCH_SUPPORTED_LANGUAGES_SUCCESS = 'languages/FETCH_SUPPORTED_LANGUAGES_SUCCESS'
const FETCH_SUPPORTED_LANGUAGES_FAIL = 'languages/FETCH_SUPPORTED_LANGUAGES_FAIL'

export const ACTIONS = {
  FETCH_SUPPORTED_LANGUAGES,
  FETCH_SUPPORTED_LANGUAGES_SUCCESS,
  FETCH_SUPPORTED_LANGUAGES_FAIL
}

export default (state = initalState, { type, payload }) => {
  switch (type) {
    case FETCH_SUPPORTED_LANGUAGES:
      return {
        ...state,
        fetchingLanguages: true,
        fetchingLanguagesError: null
      }
    case FETCH_SUPPORTED_LANGUAGES_SUCCESS:
      return {
        ...state,
        fetchingLanguages: false,
        fetchedLanguages: true,
        languages: Array.isArray(payload)
          ? payload
          : payload && Array.isArray(payload.languages)
          ? payload.languages
          : []
      }
    case FETCH_SUPPORTED_LANGUAGES_FAIL:
      return {
        ...state,
        fetchingLanguages: false,
        fetchedLanguages: true,
        fetchingLanguagesError: payload
      }
    default:
      return state
  }
}

export const fetchLanguages = () =>
  capiCreator(
    FETCH_SUPPORTED_LANGUAGES,
    FETCH_SUPPORTED_LANGUAGES_SUCCESS,
    FETCH_SUPPORTED_LANGUAGES_FAIL,
    () => axios.get('/languages', { headers: { 'x-api': 'positions_v1' } })
  )



// WEBPACK FOOTER //
// ./src/redux/reducers/languages.js